import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { transport } from "@/mock";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut", delay: i * 0.1 },
  }),
};

export const Transport = () => {
  return (
    <section
      id="transport"
      data-testid="transport-section"
      className="relative bg-[#0A0A0A] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="relative order-2 lg:order-1"
        >
          <div className="overflow-hidden rounded-2xl border border-[#D4AF37]/20 bg-[#111111]">
            <img
              src={transport.image}
              alt="Transport funebër ndërkombëtar"
              className="w-full h-[420px] object-contain hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="hidden lg:block absolute -top-6 -right-6 h-32 w-32 border border-[#D4AF37]/40 rounded-2xl -z-0" />
        </motion.div>

        <motion.div
          variants={fadeUp}
          custom={1}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="order-1 lg:order-2"
        >
          <p className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            {transport.overline}
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5F5F5] tracking-tight leading-tight">
            {transport.title}
          </h2>
          <p className="mt-5 text-base text-gray-400 leading-relaxed max-w-lg">
            {transport.subtitle}
          </p>

          <div className="mt-8 space-y-4">
            {transport.routes.map((r, i) => (
              <div
                key={i}
                data-testid={`transport-route-${i}`}
                className="bg-[#1A1A1A] border border-[#D4AF37]/20 rounded-xl p-5 hover:border-[#D4AF37]/60 transition-colors duration-500"
              >
                <div className="flex items-center gap-3 text-[#F5F5F5]">
                  <span className="font-serif text-xl">{r.from}</span>
                  <ArrowRight size={18} strokeWidth={1.5} className="text-[#D4AF37]" />
                  <span className="font-serif text-xl">{r.to}</span>
                </div>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed">
                  {r.description}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
